import { createRoute } from "@tanstack/react-router";
import { z } from "zod";
import { SignInPage, signInSearchSchema } from "@amber/access/ui";
import { searchParam } from "@amber/ui";
import { NoAccessPage } from "../pages/NoAccess";
import { rootRoute } from "./root";

export const signInRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/sign-in",
  validateSearch: signInSearchSchema,
  component: function SignInRoute() {
    return <SignInPage search={signInRoute.useSearch()} />;
  },
});

export const noAccessRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/no-access",
  validateSearch: z.object({ what: searchParam(z.string()) }),
  component: function NoAccessRoute() {
    return <NoAccessPage what={noAccessRoute.useSearch().what} />;
  },
});
